(() => {
  const clearRetiredPromotion = () => {
    document.querySelectorAll(".tdf-gift, #tdf-style").forEach((element) => element.remove());
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", clearRetiredPromotion, { once: true });
  } else {
    clearRetiredPromotion();
  }
  document.addEventListener("cart:updated", clearRetiredPromotion);
  document.addEventListener("cart:refresh", clearRetiredPromotion);
})();
